import service from "@/store/services/payment-terms-service";

export const state = () => ({
  list: {},
  paymentTerm: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, paymentTerm) => {
    state.paymentTerm = paymentTerm;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((paymentTerm) => {
      commit("SET_RESOURCE", paymentTerm);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((paymentTerm) => {
      commit("SET_RESOURCE", paymentTerm);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((paymentTerm) => {
      commit("SET_RESOURCE", paymentTerm);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  paymentTerm: (state) => state.paymentTerm,
  url: (state) => state.url,
};

const paymentTermes = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default paymentTermes;
